const pesos = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' });
const fecha = new Intl.DateTimeFormat('es-MX', {
  dateStyle: 'medium',
  timeZone: 'America/Mexico_City',
});

/** "1234.50" (texto decimal del API, nunca número de punto flotante en el origen) → "$1,234.50". */
export function mxn(cantidad: string | null | undefined): string {
  if (cantidad === null || cantidad === undefined || cantidad === '') return '—';
  return pesos.format(Number(cantidad));
}

const fechaSinHora = new Intl.DateTimeFormat('es-MX', { dateStyle: 'medium', timeZone: 'UTC' });

/** Fecha corta en México. Una fecha sin hora (AAAA-MM-DD) es un día del calendario: no se convierte de zona. */
export const fechaCorta = (valor: string | Date | null | undefined) => {
  if (!valor) return '—';
  if (typeof valor === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(valor))
    return fechaSinHora.format(new Date(`${valor}T00:00:00Z`));
  return fecha.format(new Date(valor));
};

/** Valor para un <input type="datetime-local"> en la hora del equipo (no en UTC). */
export function fechaHoraLocal(d: Date): string {
  const dos = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${dos(d.getMonth() + 1)}-${dos(d.getDate())}T${dos(d.getHours())}:${dos(d.getMinutes())}`;
}
